/*
 * @Author: yanyongchao
 * @Date: 2018-12-28 09:38:40
 */
import Vue from 'vue'
import Router from 'vue-router'
import { digitalMarketing } from './digitalMarketing'
import { helpPages } from './help'
import { depositAuthPages } from './depositAuth'
import { billRouter } from './bill'
import { codeOrderBillRouter } from './codeOrderBill'
import questionnaire from './questionnaire'
import { gasStationRouter } from './gasStation'
import { teachTrain } from './teachTrain'
import { teachAssistant } from './teachAssistant'
import { poster, newPoster } from './poster'
import { riskAppeal } from './riskAppeal'
import { stateSubsidiesRouter } from './stateSubsidies'
import { expiredCertificationUpdateInfo } from './expiredCertificationUpdateInfo' // 过期认证更新信息
import { receiptManager } from './receiptManager'
import store from 'store'
import { getAppAuthInfoServer } from '@/api/appAuth'
import { JurisdictionName } from './JurisdictionName'
import { loanTypesSummary, loanMerchantE, loanPersonal } from './loanPage' // 贷超 预授信模式
import { electronicInvoice } from './electronicInvoice' // 电子发票
import { instantInvoicing } from './instantInvoicing' // 支付即开票
import { merchantInfoRouter } from './merchantInfo'
import { revenueSharingRouter } from './revenueSharing'
import { aiMarketing } from './aiMarketing'
import { aiManager } from './aiManager'
import { staffRouter } from './staff'
import { memberRouter } from './member'
import { trafficCoinRouter } from './trafficCoin'
import { storeDiscountRouter } from './storeDiscount'
// import FsLoadings from '../components/FsLoadings/loading'
import { VuePageStack } from '@/untils/routerPageStack.js'
Vue.use(Router)
let hasAccessToken = false // 表示当前有accessToken, 离开app自动销毁
const router = new Router({
  mode: 'history',
  routes: [
    ...billRouter,
    ...codeOrderBillRouter, // 扫码点单账单统计
    ...digitalMarketing, // 数字营销中心模块页面
    ...helpPages, // 帮助页面
    ...depositAuthPages, // 酒店预授权页面
    ...questionnaire,
    ...gasStationRouter, // 加油站页面
    ...teachTrain, // 教培行业页面
    ...loanTypesSummary, // 贷超前置
    ...loanMerchantE, // 预授信模式
    ...loanPersonal, // 个人贷
    ...teachAssistant, // 小助教页面
    ...poster, // 海报页面
    ...riskAppeal, // 风控申诉页面
    ...newPoster,
    ...stateSubsidiesRouter,
    ...electronicInvoice, // 电子发票
    ...instantInvoicing, // 支付即开票
    ...expiredCertificationUpdateInfo, // 过期认证更新信息
    ...receiptManager,
    ...merchantInfoRouter, // 商户信息
    ...aiMarketing, // 智能营销
    ...aiManager, // ai助手管理
    ...revenueSharingRouter, // 分账管理
    ...staffRouter, // 员工管理
    ...memberRouter, // 会员管理
    ...trafficCoinRouter, // 流量币
    ...storeDiscountRouter, // 门店折扣
    {
      path: '/integral/i/:id',
      name: 'integral',
      component: () => import('views/integral/index.vue'),
      meta: {
        title: '我的积分'
      }
    },
    {
      path: '/integral/rule',
      name: 'integralRule',
      component: () => import('views/integral/rule.vue'),
      meta: {
        title: '积分规则'
      }
    },
    {
      path: '/integral/mall',
      name: 'integralMall',
      component: () => import('views/integral/mall.vue'),
      meta: {
        title: '积分商城'
      }
    },
    // 主页面(平安+非平安)
    {
      path: '/hardware/i/:id',
      name: 'hardwareHome',
      component: () => import('views/hardwareHome/both/index.vue')
    },
    // 主页面(仅平安)
    {
      path: '/hardware/pingan',
      name: 'hardwarePingan',
      component: () => import('views/hardwareHome/pingan/index.vue')
    },
    // 主页面(仅非平安)
    {
      path: '/hardware/notPingan',
      name: 'hardwareNotPingan',
      component: () =>
        import('views/hardwareHome/notPingan/index.vue')
    },
    // 退款须知页面
    {
      path: '/refund/notice',
      name: 'refundNotice',
      component: () => import('views/common/refundNotice.vue')
    },
    // 平安退款须知页面
    {
      path: '/hardware/pinganNotice',
      name: 'hardwarePinganNotice',
      component: () => import('views/hardwareHome/pingan/pinganNotice.vue')
    },
    // 平安申请单超过1000的中转页面
    {
      path: '/hardware/pinganTransit',
      name: 'hardwarePinganTransit',
      component: () => import('views/hardwareHome/pinganTransit/index.vue')
    },
    // 平安下载申请单页面
    {
      path: '/hardware/pinganInfoImg',
      name: 'hardwarePinganInfoImg',
      component: () => import('views/hardwareHome/pingan/pinganInfoImg.vue')
    },
    // 申请退款列表
    {
      path: '/hardware/equipment',
      name: 'hardwareEquipment',
      component: () =>
        import('views/hardwareRefund/equipment/index.vue')
    },
    // 申请退款表单
    {
      path: '/hardware/apply',
      name: 'hardwareApply',
      component: () => import('views/hardwareRefund/apply/index.vue')
    },
    // 申请记录列表
    {
      path: '/hardware/record',
      name: 'hardwareRecord',
      component: () => import('views/hardwareRecord/record/index.vue')
    },
    // 申请记录详情
    {
      path: '/hardware/record/detail/:id',
      name: 'hardwareRecordDetail',
      component: () => import('views/hardwareRecord/detail/index.vue')
    },
    {
      path: '/loan',
      name: 'loan',
      component: () => import('views/loan/index.vue')
    },
    {
      path: '/loan/noPower',
      name: 'noPower',
      component: () => import('views/loan/noPower.vue')
    },
    {
      path: '/loan/updateVersion',
      name: 'updateVersion',
      component: () => import('views/loan/updateVersion.vue')
    },
    {
      path: '/loan/phoneLimit',
      name: 'phoneLimit',
      component: () => import('views/loan/phoneLimit.vue')
    },
    {
      path: '/cate/agreement',
      name: 'cateAgreement',
      component: () => import('views/agreement/cate.vue'),
      meta: {
        title: '扫码点餐相关协议'
      }
    },
    {
      path: '/privacy/tempAgreement',
      name: 'tempAgreement',
      component: () => import('views/agreement/tempAgreement.vue'),
      meta: {
        title: '隐私协议'
      }
    },
    {
      path: '/scanOrder/agreement',
      name: 'scanOrderAgreement',
      component: () => import('views/agreement/scanOrder.vue'),
      meta: {
        title: '扫码点单相关协议'
      }
    },
    {
      path: '/faceEquipment/agreement',
      name: 'faceEquipmentAgreement',
      component: () => import('views/agreement/faceEquipment.vue'),
      meta: {
        title: '设备管理'
      }
    },
    {
      path: '/serviceDetail/agreement',
      name: 'serviceDetailContent',
      component: () => import('views/agreement/serviceDetail.vue'),
      meta: {
        title: '通知详情'
      }
    },
    {
      path: '/privacy/agreement',
      name: 'privacyAgreement',
      component: () => import('views/agreement/privacy.vue'),
      meta: {
        title: '隐私协议'
      }
    },
    {
      path: '/privacy/thirdSdk',
      name: 'thirdSdk',
      component: () => import('views/agreement/thirdSdkList.vue'),
      meta: {
        title: '付呗App第三方SDK目录'
      }
    },
    {
      path: '/privacy/thirdSdkForIos',
      name: 'thirdSdkForIos',
      component: () => import('views/agreement/thirdSdkListForIos.vue'),
      meta: {
        title: '付呗App第三方SDK目录'
      }
    },
    {
      path: '/privacy/bankSplitSms',
      name: 'bankSplitSms',
      component: () => import('views/agreement/bankSplitSms.vue'),
      meta: {
        title: '分账详情'
      }
    },
    {
      path: '/service/serviceDetail',
      name: 'serviceDetail',
      component: () => import('views/service/serviceDetail.vue'),
      meta: {
        title: '通知详情'
      }
    },
    {
      path: '/service/newsDetail',
      name: 'newsDetail',
      component: () => import('views/service/newsDetail.vue'),
      meta: {
        title: ' ' // 通知详情，默认空，到页面时通过接口获取，防止title会闪
      }
    },
    {
      path: '/service/groupBind',
      name: 'groupBind',
      component: () => import('views/service/groupBind.vue'),
      meta: {
        title: '集团绑定申请'
      }
    },
    {
      path: '/service/groupAuthProtocol',
      name: 'groupAuthProtocol',
      component: () => import('views/service/groupAuthProtocol.vue'),
      meta: {
        title: '授权协议'
      }
    },
    {
      path: '/wxMarket/index',
      name: 'wxMarket',
      component: () => import('views/wxMarket/index.vue'),
      meta: {
        title: '微信营销'
      }
    },
    {
      path: '/wxMarket/detail',
      name: 'wxMarketDetail',
      component: () => import('views/wxMarket/detail.vue'),
      meta: {
        title: '微信营销详情'
      }
    },
    {
      path: '/wxMarket/blank',
      name: 'wxMarketBlank',
      component: () => import('views/wxMarket/blank.vue'),
      meta: {
        title: '微信营销空白页'
      }
    },
    { // 花呗分期首页
      path: '/antCreditPay/index',
      name: 'antCreditPayIndex',
      component: () => import('views/antCreditPay/index.vue'),
      meta: {
        title: '花呗分期'
      }
    },
    { // 花呗分期信息页
      path: '/antCreditPay/info',
      name: 'antCreditPayInfo',
      component: () => import('views/antCreditPay/info.vue'),
      meta: {
        title: '花呗分期'
      }
    },
    { // 花呗分期设置页
      path: '/antCreditPay/set',
      name: 'antCreditPaySet',
      component: () => import('views/antCreditPay/set.vue'),
      meta: {
        title: '花呗分期'
      }
    },
    {
      path: '/antCreditPay/comProblem',
      name: 'antCreditPayProblem',
      component: () => import('views/antCreditPay/comProblem.vue'),
      meta: {
        title: '花呗分期'
      }
    },
    {
      path: '/antCreditPay/problemDetail',
      name: 'antCreditPayProblemDetail',
      component: () => import('views/antCreditPay/problemDetail.vue'),
      meta: {
        title: '花呗分期'
      }
    },
    { // 会员招募入口
      path: '/memberConscribe/index',
      name: 'memberConscribe',
      component: () => import('views/memberConscribe/index.vue'),
      meta: {
        title: '会员招募'
      }
    },
    { // 会员活动创建页
      path: '/memberConscribe/createMemberActivity',
      name: 'createMemberActivity',
      component: () => import('views/memberConscribe/createMemberActivity.vue'),
      meta: {
        title: '会员活动',
        keepAlive: true
      }
    },
    { // 分等级返现
      path: '/memberConscribe/consumeGraduation',
      name: 'consumeGraduation',
      component: () => import('views/memberConscribe/consumeGraduation.vue'),
      meta: {
        title: '设置消费返',
        keepAlive: true
      }
    },
    { // 等比例返现
      path: '/memberConscribe/consumeRatio',
      name: 'consumeRatio',
      component: () => import('views/memberConscribe/consumeRatio.vue'),
      meta: {
        title: '设置消费返',
        keepAlive: true
      }
    },
    { // 百分比返现
      path: '/memberConscribe/consumePercent',
      name: 'consumePercent',
      component: () => import('views/memberConscribe/consumePercent.vue'),
      meta: {
        title: '设置消费返',
        keepAlive: true
      }
    },
    { // 会员活动列表页
      path: '/memberConscribe/memberActivityList',
      name: 'memberActivityList',
      component: () => import('views/memberConscribe/memberActivityList.vue'),
      meta: {
        titile: '全部会员活动',
        keepAlive: true
      }
    },
    { // 活动详情页
      path: '/memberConscribe/memberActivityDetail/:id',
      name: 'memberActivityDetail',
      component: () => import('views/memberConscribe/memberActivityDetail.vue'),
      meta: {
        title: '活动详情',
        keepAlive: true
      }
    },
    { // 会员活动发布成功
      path: '/memberConscribe/createMemberActivitySuccess',
      name: 'createMemberActivitySuccess',
      component: () => import('views/memberConscribe/createMemberActivitySuccess.vue'),
      meta: {
        title: '发布成功'
      }
    },
    { // 我的-门店二维码
      path: '/shopQrcode/index',
      name: 'shopQrcodeIndex',
      component: () => import('views/shopQrcode/index.vue'),
      meta: {
        title: '门店二维码',
        keepAlive: true
      }
    },
    { // 收款二维码详情
      path: '/shopQrcode/casherQrcode/index',
      name: 'casherQrcodeIndex',
      component: () => import('views/shopQrcode/casherQrcode/index.vue'),
      meta: {
        title: '收款二维码'
      }
    },
    { // 小程序二维码详情
      path: '/shopQrcode/miniProgramQrcode/index',
      name: 'miniProgramQrcodeIndex',
      component: () => import('views/shopQrcode/miniProgramQrcode/index.vue'),
      meta: {
        title: '小程序二维码'
      }
    },
    {
      path: '/app/update',
      name: 'appUpdate',
      component: () => import('views/appUpdate/index.vue'),
      meta: {
        title: 'app升级'
      }
    },
    {
      path: '/registration/protocol',
      name: 'registrationProtocol',
      component: () => import('views/agreement/registrationProtocol.vue'),
      meta: {
        title: '商户注册以及开通服务协议'
      }
    },
    {
      path: '/thirdAuth/protocol',
      name: 'thirdAuthProtocol',
      component: () => import('views/agreement/thirdAuthPotocol.vue'),
      meta: {
        title: '协议'
      }
    },
    {
      path: '/registration/view/protocol',
      name: 'viewProtocol',
      component: () => import('views/agreement/viewProtocol.vue'),
      meta: {
        title: '协议'
      }
    },
    {
      path: '*',
      component: () => import('views/common/404.vue')
    }
  ],
  scrollBehavior: (to, from, savedPosition) => {
    return { x: 0, y: 0 }
  }
})
const noTokenWhiteList = [
  'privacyAgreement',
  'tempAgreement',
  'bankSplitSms',
  'thirdAuthProtocol',
  'viewProtocol'
]

/**
 * @function persistOemChineseName
 * @description 对齐 Angular auth.oemChineseName（pushInfo.getAppInfo → getAppInfoFunc）
 */
function persistOemChineseName (oemChineseName) {
  if (oemChineseName) {
    sessionStorage.setItem('oemChineseName', oemChineseName)
  }
}

/**
 * @function isLocalDebugHost
 * @description 仅 localhost / 局域网，用于本地无原生桥时的 token 兜底
 */
function isLocalDebugHost () {
  if (typeof location === 'undefined') return false
  const host = location.hostname
  return host === 'localhost' || host === '127.0.0.1' ||
    /^192\.168\./.test(host) || /^10\./.test(host) ||
    /^172\.(1[6-9]|2\d|3[0-1])\./.test(host)
}

/**
 * @function tryLocalTokenCacheFallback
 * @description 非 production + 本地域名：桥无响应时用 localStorage，避免浏览器白屏。
 * App 打开远程域名不走此逻辑，避免抢跑过期 token。
 */
function tryLocalTokenCacheFallback (to, from, next) {
  if (process.env.VUE_APP_MODE === 'production' || !isLocalDebugHost()) return
  setTimeout(() => {
    if (hasAccessToken) return
    const cached = localStorage.getItem('access_token')
    if (!cached) return
    hasAccessToken = true
    store.dispatch('SetAccessToken', cached)
    routerBeforeEachHandle(to, from, next)
  }, 800)
}

/**
 * 路由跳转之前   判断一下taken 存session 更新local
 * */
router.beforeEach((to, from, next) => {
  if (to.meta && to.meta.title) {
    document.title = to.meta.title
  }
  console.log('to', to)
  let accessToken = to.query.access_token || to.query.accessToken || ''
  console.log('beforeEach', accessToken, hasAccessToken)
  // 带有参数isShare，是分享业务不需要accessToken，直接绕过获取token
  if (to.query.isShare) {
    next()
    return
  }
  // 在无token白名单中时可以直接访问页面
  console.log(to.name, 'nnnnnnnnn')
  if (noTokenWhiteList.includes(to.name)) {
    next()
    return
  }
  console.log('beforeEach', to)

  if (accessToken) {
    localStorage.setItem('access_token', accessToken)
    store.dispatch('SetAccessToken', accessToken)
    hasAccessToken = true
    routerBeforeEachHandle(to, from, next)
  } else if (!hasAccessToken) {
    window.$jfs.getAppInfoFunc()
      .then(res => {
        console.log('获取到信息了:', res)
        hasAccessToken = true
        localStorage.setItem('access_token', res.accessToken)
        sessionStorage.setItem('uid', res.uid) // 获取该商户的uid
        persistOemChineseName(res.oemChineseName)
        store.dispatch('SetAccessToken', res.accessToken)
        routerBeforeEachHandle(to, from, next)
      })
    tryLocalTokenCacheFallback(to, from, next)
  } else {
    routerBeforeEachHandle(to, from, next)
  }
})

/**
 * @function 处理路由进入前操作；确保获取到accessToken后再执行，这边做封装
 * @param {function} next
 */
function routerBeforeEachHandle (to, from, next) {
  if (JurisdictionName.indexOf(to.name) !== -1 && !to.meta.hasRequest) {
    // FsLoadings.show()
    getAppAuthInfoServer().then(res => {
      // 数字营销项目获取权限接口
      // FsLoadings.hide()
      if (res.success) {
        to.meta.hasRequest = 1 // 标记该路由页面已经请求过,无需在请求
        let {
          roleType,
          storeIds,
          subConfigId, // oem标识，值不为0时为oem
          markertingActivity, // 是否具有特价活动权限
          haveWechatCoupon,
          markertingActivityNoPermissionTip,
          uid,
          ownRun,
          haveMemberFriendData,
          customerAddFriend,
          haveMemberPermission, // 是否具有会员营销
          dishes, // 是否具有扫码点单
          easyDish, // 是否是轻松点
          masterRefund // 店长是否有退款权限（员工模块对齐 Angular）
        } = res.data
        sessionStorage.setItem('roleType', roleType) // 获取角色权限 0 - 总帐号 老板账号 1 - 店长 2 - 收银员 3 - 服务员
        if (masterRefund !== undefined && masterRefund !== null) {
          sessionStorage.setItem('masterRefund', masterRefund)
        }
        let actives = {
          markertingActivity, // 特价活动权限
          markertingActivityNoPermissionTip // 特价活动没权限的提示
        }
        sessionStorage.setItem('actives', JSON.stringify(actives)) // 获取营销玩法权限
        sessionStorage.setItem('ownRun', ownRun) // 获取是否展示营销玩法入口
        sessionStorage.setItem('customerAddFriend', customerAddFriend) // 获取是否有顾客加好友权限
        sessionStorage.setItem('storeIds', JSON.stringify(storeIds)) // 获取该商户的门店id
        sessionStorage.setItem('uid', uid) // 获取该商户的uid
        sessionStorage.setItem('haveMemberFriendData', JSON.stringify(haveMemberFriendData)) // 有存量会员加好友的数据
        sessionStorage.setItem('easyDish', JSON.stringify(easyDish)) // 是否是轻松点 是否有分享小程序权限
        sessionStorage.setItem('haveWechatCoupon', haveWechatCoupon) // 有存量会员加好友的数据
        sessionStorage.setItem('subConfigId', subConfigId) // oem 标识

        // 存储一个判断是否展示商家小程序二维码的字段 haveMinaQrcodePermission
        // 如果有轻松点，或者是oem商户则不展示小程序二维码
        // 有扫码点单、特价活动、会员营销中的任意一个权限，则门店二维码中展示小程序二维码
        if (easyDish === 1 || +subConfigId !== 0) {
          sessionStorage.setItem('haveMinaQrcodePermission', '2')
        } else if (haveMemberPermission === 1 || markertingActivity === 1 || dishes === 1) {
          // 1-有
          sessionStorage.setItem('haveMinaQrcodePermission', '1')
        } else {
          // 2-无
          sessionStorage.setItem('haveMinaQrcodePermission', '2')
        }
      }
      next()
    }).catch(err => {
      // FsLoadings.hide()
      console.log('获取权限报错', err)
      next()
    })
  } else {
    console.log('不是会员营销相关页面')
    next()
  }
}

/**
 * 路由跳转成功之后
 * */
router.afterEach((to, from) => {
  VuePageStack(to)
})

export default router
